import { Breadcrumbs } from "@mui/material";
import React from "react";
import { useLocation } from "react-router-dom";
import StyledLinkBtn from "./styled-link-btn";
import DoNotDisturbOnTotalSilenceIcon from "@mui/icons-material/DoNotDisturbOnTotalSilence";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";

const UsersBreadcrumb = () => {
  const location = useLocation();

  const isOnUsersPage = location.pathname === "/users";
  const currentOrParentPath = isOnUsersPage ? "." : "..";

  return (
    <div role="presentation" style={{ marginTop: "10px" }}>
      <Breadcrumbs separator="" aria-label="breadcrumb">
        <StyledLinkBtn
          label="Benutzer"
          icon={<DoNotDisturbOnTotalSilenceIcon fontSize="medium" />}
          path={currentOrParentPath}
        />

        <StyledLinkBtn
          label="Kundenbenutzer"
          icon={<PowerSettingsNewIcon fontSize="medium" />}
          path={`${currentOrParentPath}/clients`}
        />
      </Breadcrumbs>
    </div>
  );
};

export default UsersBreadcrumb;